import { render, staticRenderFns } from "./MostClient.vue?vue&type=template&id=202928be&"
import script from "./MostClient.vue?vue&type=script&lang=js&"
export * from "./MostClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MostClient.vue"
export default component.exports